export default "__VITE_ASSET__HrAYNoD6__"